export enum ItemTypes {
  Country = 'Country',
  Region = 'Region',
  Governorate = 'Governorate',
  District = 'District'
}
